const elPaginationKey = Symbol("elPaginationKey");

export { elPaginationKey };
//# sourceMappingURL=pagination.mjs.map
